module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_23.10e8fb3b.jpg";